<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0003#_idParaDest-1">Dedication</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0004#_idParaDest-2">Acknowledgements</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0005#_idParaDest-3">PROLOGUE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0006#_idParaDest-4">CHAPTER ONE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0007#_idParaDest-5">CHAPTER TWO</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0008#_idParaDest-6">CHAPTER THREE</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/part0009#_idParaDest-7">CHAPTER FOUR</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0010#_idParaDest-8" title="Link target outside of Sample">CHAPTER FIVE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0011#_idParaDest-9" title="Link target outside of Sample">CHAPTER SIX</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0012#_idParaDest-10" title="Link target outside of Sample">CHAPTER SEVEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0013#_idParaDest-11" title="Link target outside of Sample">CHAPTER EIGHT</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0014#_idParaDest-12" title="Link target outside of Sample">CHAPTER NINE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0015#_idParaDest-13" title="Link target outside of Sample">CHAPTER TEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0016#_idParaDest-14" title="Link target outside of Sample">CHAPTER ELEVEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0017#_idParaDest-15" title="Link target outside of Sample">CHAPTER TWELVE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0018#_idParaDest-16" title="Link target outside of Sample">CHAPTER THIRTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0019#_idParaDest-17" title="Link target outside of Sample">CHAPTER FOURTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0020#_idParaDest-18" title="Link target outside of Sample">CHAPTER FIFTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0021#_idParaDest-19" title="Link target outside of Sample">CHAPTER SIXTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0022#_idParaDest-20" title="Link target outside of Sample">CHAPTER SEVENTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0023#_idParaDest-21" title="Link target outside of Sample">CHAPTER EIGHTEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0024#_idParaDest-22" title="Link target outside of Sample">CHAPTER NINETEEN</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0025#_idParaDest-23" title="Link target outside of Sample">CHAPTER TWENTY</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0026#_idParaDest-24" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0027#_idParaDest-25" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0028#_idParaDest-26" title="Link target outside of Sample">CHAPTER TWENTY-THREE</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/part0029#_idParaDest-27" title="Link target outside of Sample">CHAPTER TWENTY-FOUR</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0002.vue?75446452